import axios from "axios";
import { serviceKeys } from "../../constants";

export const signUp = async (payload) => {
  const response = await axios.post(
    `${serviceKeys.BASE_URL}api/v1/storefront/auth/signup/`,
    payload
  );
  return response.data;
};

export const logIn = async (payload) => {
  const response = await axios.post(
    `${serviceKeys.BASE_URL}api/v1/storefront/auth/login/`,
    payload
  );
  return response.data;
};

export const resetPassword = async (token, password) => {
  const response = await axios.post(
    `${serviceKeys.BASE_URL}api/v1/storefront/auth/reset-password/`,
    { token, password: password }
  );
  return response.data;
};

export const requestPasswordReset = async (email) => {
  const response = await axios.post(
    `${serviceKeys.BASE_URL}api/v1/storefront/auth/forgot-password/`,
    { email }
  );
  return response.data;
}

export const getMyOrders = async (token, limit = 10, offset = 0) => {
  const response = await axios.get(
    `${serviceKeys.BASE_URL}api/v1/storefront/my-orders/?limit=${limit}&offset=${offset}`,
    { headers: { Authorization: `Bearer ${token}` } }
  );
  return response.data;
};

export const getMyTickets = async (token, limit = 10, offset = 0) => {
  const response = await axios.get(
    `${serviceKeys.BASE_URL}api/v1/storefront/my-tickets/?limit=${limit}&offset=${offset}`,
    { headers: { Authorization: `Bearer ${token}` } }
  );
  return response.data;
}

export const requestOtpForMail = async (email, otpFor) => {
  const response = await axios.post(
    `${serviceKeys.BASE_URL}api/v1/storefront/email-otp/request/`, {
      email: email,
      otp_for: otpFor,
    }
  );
  return response.data;
};


export const verifyOtpForMail = async (email, otp, otpFor) => {
  const response = await axios.post(
    `${serviceKeys.BASE_URL}api/v1/storefront/email-otp/verify/`, {
      email: email,
      otp_code: otp,
      otp_for: otpFor,
    }
  );
  return response.data;
};
